module.exports = __webpack_public_path__ + "static/media/se_page5.509e1729.ogg";